module.exports = __webpack_public_path__ + "img/组 13.c0a8c840.png";